<template>
  <div>
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          @submit.native.prevent
        >
          <el-form-item label="老人姓名">
            <el-input
              clearable
              v-model.trim="formInline.oldName"
              placeholder="请输入老人姓名"
              style="width: 140px;"
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="老人身份证">
            <el-input
              clearable
              v-model.trim="formInline.idCard"
              placeholder="请输入老人身份证"
              @keyup.enter.native.prevent="enterSearchMember"
            ></el-input>
          </el-form-item> -->
          <!-- <el-form-item label="性别">
            <el-select v-model="formInline.sex" style="width: 150px" clearable>
              <el-option value="0" label="男"></el-option>
              <el-option value="1" label="女"></el-option>
            </el-select>
          </el-form-item> -->
          
          <el-form-item label="老人类型">
            <el-select
              v-model="formInline.peopleType"
              style="width: 140px"
              clearable
              @change="statusChange"
            >
              <el-option
                v-for="item in personReduceOptions"
                :key="item.id"
                :label="item.userTypeName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <!-- <el-form-item label="入院状态">
            <el-select
              v-model="formInline.status"
              style="width: 140px"
              clearable
              @change="statusChange"
            >
              <el-option
                v-for="item in statusItem"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
              plain
              >查询</el-button
            >
            <el-button
              type="warning"
              icon="el-icon-plus"
              @click="addOrder"
              plain
              >添加</el-button
            >
            <el-button
              type="info"
              @click="downOldTemplateByGroup"
              icon="el-icon-document"
              plain
              >模板下载</el-button
            >
              <el-button
                type="info"
                @click="toLead"
                icon="el-icon-upload"
                plain
                style="margin-left: 10px"
                >入院信息上传</el-button
              >
              <el-button
                type="info"
                @click="toLeadJm"
                icon="el-icon-upload"
                plain
                style="margin-left: 10px"
                >金民系统导入</el-button
              >
              <el-button
              type="info"
              @click="downOldManByGroup"
              icon="el-icon-download"
              plain
              >入院报表导出</el-button
            >
          </el-form-item>
        </el-form>
        <el-table
          style="width: 100%"
          :data="tableData"
          v-loading="tableLoading"
          ref="multipleTable"
          :header-cell-style="{
            'text-align': 'center',
            'font-size': '16px',
            'font-weight': '600',
            color: '#2d2d2d',
            'background-color': '#d4f5fa',
          }"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :row-style="tableRowStyle"
        >
          <el-table-column
            prop="oldName"
            label="老人姓名"
            min-width="100"
          ></el-table-column>
          
          <el-table-column
            prop="oldIdCard"
            label="身份证号"
            min-width="166"
          ></el-table-column>
          <el-table-column
            prop="sex"
            label="性别"
            min-width="50"
          ></el-table-column>
          <el-table-column
            prop="peopleType"
            label="老人类型"
            :formatter="formatType"
            show-overflow-tooltip
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="egNamea"
            label="紧急联系人"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="egPhonea"
            label="紧急联系电话"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="newBedNo"
            label="床位号"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="levelCareName"
            label="自理类型"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="registryTime"
            label="入院时间"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="creator"
            label="经办人"
            show-overflow-tooltip
            min-width="100"
          ></el-table-column>
          <el-table-column label="操作" min-width="130">
            <template slot-scope="scope">
              <el-button
                style="margin-right: 5px"
                type="primary"
                size="mini"
                plain
                @click="handleEdit(scope.$index, scope.row)"
                >入院</el-button>
              <el-button
                style="margin-left: 5px"
                type="warning"
                size="mini"
                plain
                @click="handleDetail(scope.$index, scope.row)"
                >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        >
        </el-pagination>
      </el-row>
      <!-- 报表下载 -->
      <!--
        <el-dialog
          title="报表导出"
          width="420px"
          :visible.sync="downOldManByGroupVisisble"
          :close-on-click-modal="false"
          @close="closeDialog('baobiaoForm');"
          :close-on-press-escape="false"
        >
          <el-form ref="baobiaoForm" :model="baobiaoForm" label-width="100px">
            <el-form-item label="老人姓名">
              <el-select
                v-model="baobiaoForm.oldName"
                multiple
                placeholder="请选择"
              >
                <el-option
                  v-for="item in oldNameOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer" align="center">
            <el-button @click="downOldManByGroupVisisble = false;"
              >取 消</el-button
            >
            <el-button type="primary" @click="baobiaosubmitForm('baobiaoForm');"
              >确 定</el-button
            >
          </div>
        </el-dialog>
      -->
      <!-- 导出字段 -->
      <el-dialog
        title="导出字段选择"
        width="420px"
        :visible.sync="fieldsVisisble"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeDialog"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="fieldsForm"
          @change="handleCheckedCitiesChange"
          style="display: flex; flex-wrap: wrap; width: 100%"
        >
          <el-checkbox
            v-for="city in cities"
            :label="city.value"
            :key="city.value"
            size="medium"
            :disabled="city.label == '姓名'"
            style="width: 42%"
            >{{ city.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="fieldsVisisble = false">取 消</el-button>
          <el-button type="primary" @click="baobiaosubmitForm">确 定</el-button>
        </div>
      </el-dialog>
      <!-- 报表上传 -->
      <el-dialog
        title="报表导入"
        width="30%"
        :visible.sync="toLeadVisisble"
        :close-on-click-modal="false"
        @close="toLeadCloseDialog"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="file" id="file" @change="getUrl" />
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="toLeadVisisble = false">取消</el-button>
          <el-button type="primary" @click.native="intoForm">确定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import { baseURL } from "@/utils/request.js";
export default {
  name: "AdmissionOlderList",
  data() {
    return {
      formInline: {
        oldName: "",
        peopleType:'',
        idCard: "",
        sex: "",
        status: null,
      },
      tableData: [], //表格数据
      tableLoading: false, //表格加载的loading
      /* 分页的 */
      currentPage: 1, //初始页
      pageNo: 1, //页码
      pageSize: 10, //每页显示的条数
      totalDataNumber: 0, //数据的总数,
      downOldManByGroupVisisble: false,
      personReduceOptions:[],
      oldManIds: [], // 报表导出选中老人id集合
      formSelect: [
        {
          label: "男",
          value: "0",
        },
        {
          label: "女",
          value: "1",
        },
      ],
      fieldsVisisble: false,
      oldNameOptions: [], // 老人姓名集合
      statusItem: [
        // { label: "未入院", value: 0 },
        { label: "待评估", value: 1 },
        { label: "待缴费", value: 2 },
        { label: "已入院", value: 3 },
        // { label: "已出院", value: 4 },
        // { label: "试入住", value: 5 },
        // { label: "去世", value: 6 },
        // { label: "请假中", value: 7 },
        // { label: "调房调级中", value: 8 },
        // { label: "出院中", value: 9 },
        // { label: "app用户", value: 10 },
        // { label: "已评估", value: 11 },
        // { label: "待审批", value: 12 }
      ],
      // 导出字段集合
      checkAll: false,
      isIndeterminate: true,
      fieldsForm: [0],
      cities: [
        {
          value: 0,
          label: "姓名",
        },
        {
          value: 1,
          label: "年龄",
        },
        {
          value: 2,
          label: "性别",
        },
        {
          value: 3,
          label: "身份证号",
        },
        // {
        //   value: 4,
        //   label: "老人电话",
        // },
        {
          value: 5,
          label: "老人家庭住址",
        },
        {
          value: 6,
          label: "床位号",
        },
        {
          value: 7,
          label: "入院时间",
        },
        {
          value: 8,
          label: "经办人",
        },
        {
          value: 9,
          label: "是否缴费",
        },
        {
          value: 10,
          label: "状态",
        },
        {
          value: 11,
          label: "护理等级",
        },
        // {
        //   value: 12,
        //   label: "类型",
        // },
        {
          value: 13,
          label: "紧急联系人",
        },
        {
          value: 14,
          label: "紧急联系电话",
        },
        {
          value: 15,
          label: "紧急联系人与老人关系",
        },
        {
          value: 16,
          label: "紧急联系人家庭住址",
        },
      ],
      // 报表上传状态
      toLeadVisisble: false,
    };
  },
  methods: {
    //修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #e4f5f8";
      }
    },
    statusChange(val) {
      this.formInline.status = val;
    },
    formatType(row, column) {
      let typeStr = "其他老人";
      this.personReduceOptions.forEach(item=>{
        if(item.id == row.peopleType){
          typeStr = item.userTypeName;
        }
      })
      return typeStr;
    },
    /*
      添加老人
    */
    addOrder() {
      sessionStorage.setItem("hospitalType", 1); //添加的时候是hospitalType=1
      sessionStorage.removeItem("editOldmanId"); //清除oldmanId
      bus.$emit("homePage", {
        type: "jump",
        path: "/OlderDetailAdd",
        title: "入院详情",
      });
    },

    /*
      点击查询
    */
    search() {
      // console.log(this.formInline.status, "aaaaaaaa");
      if (this.formInline.oldName == "") {
        this.queryOldman(
          this.formInline.oldName,
          this.formInline.sex,
          (this.pageNo = 1)
        );
      } else {
        this.queryOldman(
          this.formInline.oldName,
          this.formInline.sex,
          (this.pageNo = 1),
          (this.pageSize = 10)
        );
      }
    },

    /*
      键盘事件 按下键盘回车 查询
    */
    enterSearchMember(e) {
      // console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.oldName != null) {
        if (this.formInline.oldName == "") {
          this.queryOldman(
            this.formInline.oldName,
            this.formInline.sex,
            (this.pageNo = 1)
          );
        } else {
          this.queryOldman(
            this.formInline.oldName,
            this.formInline.sex,
            (this.pageNo = 1),
            (this.pageSize = 10)
          );
        }
      }
    },
    handleDetail(index, row) {
      sessionStorage.setItem("oldmanId", row.oldmanId);
      bus.$emit("homePage", {
        type: "jump",
        path: "/ResidentDetail",
        title: "长者档案",
      });
    },
    /*
      修改老人信息
    */
    handleEdit(index, row) {
      // console.log(index, row);
      sessionStorage.setItem("hospitalType", 2); //修改的时候是hospitalType=2
      sessionStorage.setItem("editOldmanId", row.oldmanId);
      var isPayed = row.isPayed == "已缴" ? 1 : 0;
      sessionStorage.setItem("isPayed", isPayed); //是否已经缴费 0----未缴   1----已缴
      var status = row.status == null ? -1 : row.status;
      sessionStorage.setItem("status", status); //是否入院  -1---未入院  2----入院
      //status  0---未入院   1---待评估   2---待缴费  3---已入院  4----已出院  5---试入住  6----去世
      if (status == 4) {
        this.$alert("该老人已经出院", "提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      } else {
        bus.$emit("homePage", {
          type: "jump",
          path: "/OlderDetailAdd",
          title: "入院详情",
        });
      }
    },

    /*
      查询老人分页列表
    */
    queryOldman() {
      // console.log(this.formInline.status == "0");
      let params = {};
      if (this.formInline.oldName != "" || null || undefined) {
        params.oldName = this.formInline.oldName;
      }
      if (this.formInline.idCard != "" || null || undefined) {
        params.idCard = this.formInline.idCard;
      }
      if (this.formInline.sex != "" || null || undefined) {
        params.sex = this.formInline.sex;
      }
      if (this.formInline.peopleType != "" || null || undefined) {
        params.peopleType = this.formInline.peopleType;
      }
      // if (this.formInline.status == 0) {
      //   params.status = this.formInline.status;
      // } else {
      //   if (this.formInline.status != null || this.formInline.status != "") {
      //     params.status = this.formInline.status;
      //   }
      // }
      params.pageNo = String(this.pageNo);
      params.pageSize = String(this.pageSize);
      params.serviceType = 1;
      this.tableData = []; //请求之前先清空数据
      this.tableLoading = true;
      if (params.status === "" || params.status == null) {
        delete params.status;
      }
      this.$postJson("omc/Oldman/showOldManSupAll", params).then((res) => {
        if (res.code == 200) {
          if (res.result.list != null) {
            this.pageSize = res.result.pageSize;
            this.currentPage = res.result.pageNum;
            this.totalDataNumber = res.result.total * 1;
            // 对表格多页选中数据源做处理
            //循环遍历处理数据
            res.result.list.forEach((item) => {
              var object = {};
              object = Object.assign({}, item);
              object.sex = item.sex == 0 ? "男" : "女";
              object.isPayed = item.isPayed == 0 ? "未缴" : "已缴";
              this.tableData.push(object);
            });
            this.tableData.forEach((item) => {
              if (item.checkFlag == true) {
                this.$refs.multipleTable.toggleRowSelection(item);
              }
            });
          } else {
            this.tableData = [];
            this.pageSize = 10;
            this.currentPage = 1;
            this.totalDataNumber = 0;
          }
        } else {
          this.tableData = [];
          this.pageSize = 10;
          this.currentPage = 1;
          this.totalDataNumber = 0;
        }
        setTimeout(() => {
          this.tableLoading = false;
        }, 1000);
      });
    },
    /*
      初始页currentPage、初始每页数据数pagesize和数据data
    */
    handleSizeChange(val) {
      this.PageSize = val;
      this.queryOldman(); //刷新套餐列表的数据
    },
    /*
      当前页变化
    */
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.pageNo = val;
      this.queryOldman(); //刷新套餐列表的数据
    },
    // 老人信息模板下载
    downOldManTemplateByGroup() {
      window.location.href = baseURL + `omc/api/downOldManTemplateByGroup`;
    },
    // 老人信息报表导出
    downOldManByGroup() {
      this.$confirm('此操作将导出所有老人的信息', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.baobiaosubmitForm();
        })
      return;
      
    },
    //  模板下载
    downOldTemplateByGroup() {
      window.location.href = baseURL + `omc/api/downOldManTemplateByGroup`;
    },
    // 上传
    toLead() {
      this.toLeadJmFlag = false;
      this.toLeadVisisble = true;
    },
    toLeadJm() {
      this.toLeadJmFlag = true;
      this.toLeadVisisble = true;
    },
    getUrl(event) {
      let file = event.target.files;
      console.log(file);
      this.fileFlag = true; //by guo 2020-8-4-15:18添加
      this.toLeadForm = new FormData();
      this.toLeadForm.append("file", file[0]);
    },
    toLeadCloseDialog() {
      this.$refs.file.value = "";
    },
    // 确认上传
    intoForm() {
      if (this.fileFlag) {
        let url = 'omc/Oldman/toLeadOldMan';
        if(this.toLeadJmFlag == true){
          url = 'omc/Oldman/importJinMingOldList';
        }
        this.$postFormData(url, this.toLeadForm).then(
          (res) => {
            this.toLeadVisisble = false;
            this.fileFlag = false;
            this.toLeadForm = {};
            if (res.code == 200) {
              this.$message({ message: res.message, type: "success" });
              this.queryOldman();
            } else {
              this.$message({ message: res.message, type: "error" });
            }
          }
        );
      } else {
        this.$message({ message: "请选择文件", type: "error" });
      }
    },
    handleCheckAllChange(val) {
      console.log(val);
      let arr = [];
      this.cities.forEach((item) => {
        arr.push(item.value);
      });
      this.fieldsForm = val ? arr : [0];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.cities.length;
    },
    baobiaosubmitForm() {
      window.location.href =
        baseURL +
        `omc/api/downOldManInformationByGroup?groupId=${window.sessionStorage.getItem("groupId")}`;
      setTimeout(() => {
        this.fieldsVisisble = false;
      }, 1000);
    },
    closeDialog() {
      this.checkAll = false;
      this.isIndeterminate = true;
      this.fieldsForm = [0];
    },
    /*
      获取人员类别
    */
    queryPersonCategory() {
      let params = new Object();
      params.pageNum = 0;
      params.pageSize = 0;
      this.personReduceOptions = []; //清空数据，防止累加
      this.$postJson(
        "omc/userType/queryListWithPage",
        params
      ).then(res => {
        if (res.code == 200) {
          if (res.result.list.length > 0) {
            res.result.list.forEach(item => {
              this.personReduceOptions.push({
                userTypeName: item.userTypeName,
                id: item.id,
                userTypeCode: item.userTypeCode
              });
            });
          }
        }
      });
    },
  },
  mounted() {
    this.queryPersonCategory();
    this.queryOldman();
    this.$bus.$on("changeOldList", () => {
      this.queryOldman(); //刷新缴费记录单列表的数据
    });
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.toolbar{
  padding-left: 8px;
  padding-top: 5px;
}
::v-deep .el-dialog__header {
  height: 19px !important;
  text-align: left;
}
::v-deep .el-dialog__footer {
  text-align: center;
}
.fenye {
  padding: 30px 0;
  background: #fff;
}
.curcor{
  cursor: pointer;
  margin-left:20px;

}
</style>
